exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".XVdatagridheader .XVhelpcontrol[data-v-42e4f563],.XVdetailRow .XVhelpcontrol[data-v-42e4f563]{vertical-align:text-top}", ""]);

// exports
